__turbopack_context__.v({
  "actions": "trade-panel-module__hesPfG__actions",
  "advanced": "trade-panel-module__hesPfG__advanced",
  "buyRow": "trade-panel-module__hesPfG__buyRow",
  "buyRowFull": "trade-panel-module__hesPfG__buyRowFull",
  "empty": "trade-panel-module__hesPfG__empty",
  "heading": "trade-panel-module__hesPfG__heading",
  "inscription": "trade-panel-module__hesPfG__inscription",
  "manage": "trade-panel-module__hesPfG__manage",
  "marketAction": "trade-panel-module__hesPfG__marketAction",
  "note": "trade-panel-module__hesPfG__note",
  "panel": "trade-panel-module__hesPfG__panel",
  "primary": "trade-panel-module__hesPfG__primary",
  "quote": "trade-panel-module__hesPfG__quote",
  "rows": "trade-panel-module__hesPfG__rows",
  "secondary": "trade-panel-module__hesPfG__secondary",
  "sectionTitle": "trade-panel-module__hesPfG__sectionTitle",
  "selectRow": "trade-panel-module__hesPfG__selectRow",
  "table": "trade-panel-module__hesPfG__table",
  "tabs": "trade-panel-module__hesPfG__tabs",
  "textButton": "trade-panel-module__hesPfG__textButton",
});
